<template>
  <div class="index">
    <div class="idx-page">
      <!-- 顶部菜单等 -->
      <div
        class="nav-box"
        :class="[menuEvent ? 'menuEvent ' : 'menuEventAuto']"
      >
        <div class="n-sl"></div>
        <div class="logo"></div>
        <div class="r-nav">
          <div class="menu" @click="handleShowMenu()">
            <img
              src="../assets/img/common/menu.png"
              class="menu-img"
              v-if="menuIconFlag"
            />
            <img
              src="../assets/img/common/close.png"
              class="close-img"
              v-else
            />
          </div>
        </div>
      </div>
      <swiper
        :options="swiperOption"
        ref="goodSwiper"
        @slideChange="slideChange"
        class="index-bg"
      >
        <swiper-slide>
          <layer1 @handleVideo="videoFlag = true"  />
        </swiper-slide>

        <!-- <swiper-slide>
          <layer2
            @changeSilderDisable="changeSilderDisable"
            @changeSilderEnable="changeSilderEnable"
          />
        </swiper-slide> -->
        <swiper-slide>
          <layer3 ref="layer3" />
        </swiper-slide>
        <swiper-slide>
          <layer4 />
        </swiper-slide>
        <swiper-slide>
          <layer5 />
        </swiper-slide>
      </swiper>
    </div>
    <!-- 菜单 -->
    <div class="model menu-box" v-if="menuModel">
      <div class="nav">
        <img
          :src="menuIdx == item.id ? item.urlActive : item.url"
          alt=""
          srcset=""
          v-for="item in menuList"
          :key="item.id"
          @click="handleMenuIdx(item)"
        />
      </div>
      <div class="icon-lt">
        <div class="x-icon" @click="Twitter_page('twi')"></div>
        <div class="line"></div>
        <div class="lounge" @click="NaverLounge_page('naver')"></div>
        <div class="line"></div>
        <div class="ytb" @click="youtube_page('yt')"></div>
      </div>
    </div>

    <!-- 首页视频 -->
    <div
      v-if="videoFlag"
      class="model position-absolute"
      @click="videoFlag = false"
    >
      <div class="v-txt">
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/QUo9EcO8OD8?si=ctqyJtOWypOODSHM"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import layer1 from "./publicComponents/layer1";
// import layer2 from "./publicComponents/layer2";
import layer3 from "./publicComponents/layer3";
import layer4 from "./publicComponents/layer4";
import layer5 from "./publicComponents/layer5";

import * as swiperAni from "../commonFunction/animate.js";
export default {
  components: {
    layer1,
    // layer2,
    layer3,
    layer4,
    layer5
    // regCnt
  },
  data() {
    return {
      menuEvent: false,
      mobile: "",
      videoPlay: true, // 是否正在播放
      menuIconFlag: true,
      menuModel: false,
      menuIdx: 1,
      videoFlag: false,
      menuList: [
        {
          id: 1,
          url: require("../assets/img/common/1.png"),
          urlActive: require("../assets/img/common/1-active.png")
        },
        // {
        //   id: 2,
        //   url: require("../assets/img/common/2.png"),
        //   urlActive: require("../assets/img/common/2-active.png")
        // },
        {
          id: 2,
          url: require("../assets/img/common/3.png"),
          urlActive: require("../assets/img/common/3-active.png")
        },
        {
          id: 3,
          url: require("../assets/img/common/4.png"),
          urlActive: require("../assets/img/common/4-active.png")
        },
        {
          id: 4,
          url: require("../assets/img/common/5.png"),
          urlActive: require("../assets/img/common/5-active.png")
        }
      ],
      screenWidth: window.innerWidth,

      swiperOption: {
        direction: "vertical",
        autoHeight: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        allowTouchMove: true,
        // height: window.innerHeight, // 高度设置，占满设备高度
        mousewheel: true, //开启鼠标

        on: {
          init: function() {
            swiperAni.swiperAnimateCache(this); //隐藏动画元素
            swiperAni.swiperAnimate(this); //初始化完成开始动画
          },
          slideChangeTransitionStart: function() {
            swiperAni.swiperAnimate(this); //每个slide开始切换时也运行当前slide动画
            //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
          }
        }
      }
    };
  },
  created() {
    this.mobile =
      navigator.appVersion.indexOf("iPhone") !== -1 ? "iPhone" : "android";
  },

  methods: {
    // 预注册错误弹出框出来后，禁止页面滑动

    changeSilderDisable() {
      this.$refs.goodSwiper.swiper.mousewheel.disable();
      this.$refs.goodSwiper.swiper.allowTouchMove = false;
      this.menuEvent = true;
    },
    changeSilderEnable() {
      this.$refs.goodSwiper.swiper.mousewheel.enable();
      this.$refs.goodSwiper.swiper.allowTouchMove = true;
      this.menuEvent = false;
    },

    // // 首页按钮，点击跳转到第二页
    // handleReg() {
    //   this.$refs.goodSwiper.swiper.slideTo(1, 300, true);
    // },

    handleMenuIdx(item) {
      this.menuIdx = item.id;
      this.$refs.goodSwiper.swiper.slideTo(item.id - 1, 300, true);
      this.menuModel = false;
      this.menuModel = false;
      this.menuIconFlag = true;
    },
    Twitter_page(val) {
      this.common.goShare(val);
    },
    Discord_page(val) {
      this.common.goShare(val);
    },
    NaverLounge_page(val) {
      this.common.goShare(val);
    },
    youtube_page(val) {
      this.common.goShare(val);
    },
    handleShowMenu() {
      if (this.menuIconFlag) {
        this.menuModel = true;
        this.menuIconFlag = false;
      } else {
        this.menuModel = false;
        this.menuIconFlag = true;
      }
    },
    // 显示首页视频
    showVideo() {
      this.videoFlag = true;
    },

    slideChange() {
      const mainActiveIndex = this.$refs.goodSwiper.swiper.activeIndex;
      this.menuIdx = mainActiveIndex + 1;
      if (mainActiveIndex == 1) {
        this.initData();
      }
      if (mainActiveIndex == 2) {
        this.character();
      }
      if (mainActiveIndex == 3) {
        this.background();
      }
    },
    // 打开角色介绍页时触发
    character() {
      gtag("event", "character");
    },
    background() {
      gtag("event", "background");
    },
    // info 接口获取数据
    initData() {
      const reqTime = Math.floor(new Date().getTime() / 1000);
      let url = window.location.search;
      let preview = "unknow";

      let previewParam =
        url.indexOf("preview") >= 0
          ? this.common.getUrlParam("preview")
          : this.common.getUrlParam("preview");
      preview = previewParam || "unknow";

      this.$axios({
        method: "post",
        url: "cof/info",
        data: {
          //get这里应为params
          //请求参数
          signature: this.common.makeSignature({}, reqTime),
          reqTime: reqTime,
          preview: preview
        },
        //withCredentials:true, //局部携带cookie
        headers: {} //如果需要添加请求头可在这写
      })
        .then(res => {
          if (res.data.code === 0) {
            this.$refs.layer3.preview = res.data.data.register;
          }
        })
        .catch(err => {
          //请求失败就会捕获报错信息
          //err.response可拿到服务器返回的报错数据
        });
    }
  },
  mounted() {
    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.index {
  position: fixed;
  display: block;
  width: 100%;
  min-width: 320px;
  max-width: 750px;
  height: 100%;

  .menuEvent {
    pointer-events: none;
    opacity: 0.3;
  }

  .menuEventAuto {
    pointer-events: auto;
    opacity: 1;
  }

  .nav-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 95px;
    max-width: 750px;
    z-index: 2;

    .n-sl {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.3);
      filter: blur(3px);
      text-align: center;
    }

    .logo {
      width: 177px;
      height: 61px;
      background: url("../assets/img/common/logo.png") 50% no-repeat;
      background-size: cover;
      position: absolute;
      top: 50%;
      left: 2%;
      transform: translateY(-50%);
    }

    .r-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 5%;
      display: flex;
      align-items: center;
      gap: 32px;

      img {
        width: 100%;
        height: 100%;
        display: block;
      }

      .nav-audio {
        width: 50px;
        height: 41px;
      }

      .menu {
        transition: all 0.3s ease-in;

        .close-img {
          width: 38px;
          height: 38px;
        }

        .menu-img {
          width: 48px;
          height: 41px;
        }
      }
    }
  }

  .menu-box {
    position: absolute;
    z-index: 1;

    .nav {
      position: absolute;
      top: 14%;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 100px;

      img {
        width: 288px;
        height: 83px;
        display: block;
      }
    }

    .icon-lt {
      display: flex;
      align-items: center;
      justify-content: baseline;
      gap: 24px;
      position: absolute;
      bottom: 17%;
      left: 50%;
      transform: translateX(-50%);

      .x-icon {
        width: 47px;
        height: 49px;
        background: url("../assets/img/common/x-icon.png") no-repeat;
        background-size: 100% 100%;
      }

      .lounge {
        width: 67px;
        height: 49px;
        background: url("../assets/img/common/lounge-icon.png") no-repeat;
        background-size: 100% 100%;
      }
      .ytb {
        width: 69px;
        height: 51px;
        background: url("../assets/img/common/ytb-icon.png") no-repeat;
        background-size: 100% 100%;
      }

      .line {
        width: 2px;
        height: 35px;
        background: url("../assets/img/common/line.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }

  .video-size {
    position: absolute;
    left: 50%;
    top: 50%;
    /*保证视频内容始终居中*/
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    /*保证视频充满屏幕*/
    object-fit: cover;
  }

  .idx-page {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .index-bg {
    width: 100%;
    height: 100%;
  }
}

@media screen and (min-width: 375px) and(max-width: 429px) and (orientation: portrait) {
  .menu-box {
    .nav {
      gap: 70px !important;
      top: 12% !important;

      img {
        width: 259px !important;
        height: 74px !important;
      }
    }

    .icon-lt {
      bottom: 24% !important;
    }
  }
}

@media screen and (min-width: 638px) and (max-width: 1024px) and (orientation: portrait) {
  .menu-box {
    .nav {
      gap: 50px !important;
      top: 12% !important;
      img {
        width: 230px !important;
        height: 66px !important;
      }
    }

    .icon-lt {
      bottom: 24% !important;
    }
  }
}

// ipad scss
</style>



// WEBPACK FOOTER //
// src/components/mainIndex.vue